import { useState } from "react";
import toast from "react-hot-toast";

import { Spinner } from "@/components/ui";
import { ROUTES } from "@/constants/routes";
import { BackHeader } from "@/features/Profile/components/BackHeader";
import {
  useGetUserSubscriptionQuery,
  useUnsubscribeUserMutation,
} from "@/services/api-hooks/subscriptions";
import { gtmService } from "@/services/gtm-service";

import { CancelSubscriptionDialog } from "./components/CancelSubscriptionDialog";
import { SubscriptionCard } from "./components/SubscriptionCard";
import { SubscriptionEmpty } from "./components/SubscriptionEmpty";

export const Subscription = () => {
  const { data: subscription, isLoading } = useGetUserSubscriptionQuery();
  const { mutate: unsubscribe, isPending } = useUnsubscribeUserMutation();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleConfirm = () => {
    if (!subscription) return;
    unsubscribe(subscription.plan.id, {
      onSuccess: () => {
        toast.success("Subscription cancelled");
        gtmService.trackSubscriptionCancelScs();
        setConfirmOpen(false);
      },
      onError: (err) => {
        toast.error(err instanceof Error ? err.message : "Failed to cancel");
        gtmService.trackSubscriptionCancelFail();
      },
    });
  };

  return (
    <div className="mx-auto w-full max-w-xl px-4 py-6 sm:px-6">
      <BackHeader to={ROUTES.PROFILE} title="Manage Subscription" />

      <div className="mt-6">
        {isLoading ? (
          <div className="flex justify-center py-16">
            <Spinner />
          </div>
        ) : subscription ? (
          <SubscriptionCard
            subscription={subscription}
            onCancel={() => setConfirmOpen(true)}
            isCancelling={isPending}
          />
        ) : (
          <SubscriptionEmpty />
        )}
      </div>

      <CancelSubscriptionDialog
        open={confirmOpen}
        isPending={isPending}
        onOpenChange={setConfirmOpen}
        onConfirm={handleConfirm}
      />
    </div>
  );
};
